import LocalStorage from '@/services/LocalStorageService';
import consts from '@/static/js/consts.js';
import Axios from 'axios';

export default {
  addAsset({}, assetInfo) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      Object.keys(assetInfo).forEach((key) => {
        formData.append(key, assetInfo[key]);
      });

      Axios.post(consts.ENDPOINTS.ASSETS, formData, {
        headers: {
          Authorization: `Bearer ${LocalStorage.get('token')}`,
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
